import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ffcdc1d6&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "@/pages/assetManagement/common/style/workEmail.scss?vue&type=style&index=0&id=ffcdc1d6&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcdc1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffcdc1d6')) {
      api.createRecord('ffcdc1d6', component.options)
    } else {
      api.reload('ffcdc1d6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=ffcdc1d6&scoped=true", function () {
      api.rerender('ffcdc1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/workEmail/detail.vue"
export default component.exports